module.exports = new __parcel__URL__("intent-templates-light.eb3711d4.svg").toString();